import { render, staticRenderFns } from "./outSchoolInfo.vue?vue&type=template&id=3493c03c&scoped=true&"
import script from "./outSchoolInfo.vue?vue&type=script&lang=js&"
export * from "./outSchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./outSchoolInfo.vue?vue&type=style&index=0&id=3493c03c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3493c03c",
  null
  
)

export default component.exports